import type { UserSignUpStep } from '@/types/userType';

export type SessionSignUpStep = Uppercase<UserSignUpStep | 'USER_EMAIL_VERIFICATION'>;

export type StepType = {
    content: string;
    id: number;
    step: SessionSignUpStep;
};

export const steps: StepType[] = [
    {
        content: 'email_verification.step_name',
        id: 1,
        step: 'USER_EMAIL_VERIFICATION'
    },
    { content: 'user_infos.step_name', id: 2, step: 'USER_CREATED' },
    { content: 'connect_social_profiles.step_name', id: 3, step: 'USER_SET_UP' },
    { content: 'successful_connection.step_name', id: 4, step: 'SOCIAL_PROFILES_CONNECTED' }
];
